import React, {useContext, useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    customToast,
    DisabledContext, Dropdown, DropdownAlign, Icons, Modal,
    Text,
    Title, Variants, WidthConstrainedContainer
} from "toolbox-react-frontend-components";
import {route} from "ziggy-js";
import {useNavigate} from "react-router-dom";
import LoadingPane from "../../../components/LoadingPane";
import './index-album.css';

const IndexAlbum = (props) => {

    const navigate = useNavigate();

    const [data, setData]                           = useState(null);
    const [loaded, setLoaded]                       = useState(false);
    const [previewModalAlbum, setPreviewModalAlbum] = useState(null);
    const [deleting, setDeleting]                   = useState(false);

    const {
        disabled,
        setDisabled
    } = useContext(DisabledContext);

    useEffect(() => {
        if (!loaded) {
            loadPageData();
        }
    }, [loaded]);

    useEffect(() => {
        if (deleting) {
            handleDelete();
        }
    }, [deleting]);

    const loadPageData = () => {
        axios.get(route('api.admin.album.index'))
            .then((response) => {
                if (!!response && !!response.data) {
                    setData(response.data);
                    setLoaded(true);
                } else {
                    customToast({
                        title:      'Album data not found. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleDelete = () => {
        setDisabled(true);

        axios.delete(route('api.admin.album.destroy', {album: previewModalAlbum.id}))
            .then((response) => {
                customToast({
                    title:      'Album deleted.',
                    variant:    Variants.Success
                });

                setDisabled(false);
                setDeleting(false);
                setPreviewModalAlbum(null);
                setLoaded(false);
            })
            .catch((error) => {
                if (!!error && !!error.response && !!error.response.data) {
                    if (!!error.response.data.message) {
                        customToast({
                            title: error.response.data.message,
                            variant: Variants.Danger
                        });
                    }

                    setDeleting(false);
                    setDisabled(false);
                } else {
                    console.log(error);
                    customToast({
                        title:      'An error occurred. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            });
    }


    const albumsExists = () => {
        return !!data && !!data.data && data.data.length > 0;
    }

    const renderNoAlbums = () => {
        return (
            <Text className={'mb-0'}>
                No albums have been created.
            </Text>
        )
    }

    const renderAlbum = (key, album) => {
        return (
            <div
                key={'album-'+album.id+'-image-'+album.album_cover.id}
                className={'col-6 col-md-4 col-lg-3 album-cover mb-3'}
            >
                <div
                    className={'album-cover-overlay'}
                    style={{
                        backgroundImage: 'url('+album.album_cover.url+')'
                    }}
                >
                    <div className={'overlay-inner d-flex flex-column justify-content-between align-items-center p-2 border'}>
                        <div className={'w-100 d-flex flex-column align-items-start align-items-lg-center'}>
                            <Text className={'mb-0 fw-bold'} style={{fontSize: '0.8rem'}}>Title:</Text>
                            <Text className={'mb-0 text-lg-center'} style={{fontSize: '0.8rem'}}>{album.title}</Text>
                            <Text className={'mb-0 fw-bold'} style={{fontSize: '0.8rem'}}>Artist:</Text>
                            <Text className={'mb-0 text-lg-center'} style={{fontSize: '0.8rem'}}>{album.artist}</Text>
                        </div>
                        <Dropdown
                            label={'Actions'}
                            disabled={disabled || deleting}
                            className={'mt-2'}
                            align={DropdownAlign.Center}
                            items={[
                                {
                                    label: 'Edit',
                                    onClick: (event) => navigate(route('admin.album.edit', {album: album.id}, false)),
                                    variant: Variants.Primary,
                                    disabled: disabled || deleting,
                                }, {
                                    label: 'Delete',
                                    onClick: () => setPreviewModalAlbum(album),
                                    variant: Variants.Danger,
                                    disabled: disabled || deleting,
                                }
                            ]}
                        />
                    </div>
                </div>
            </div>
        )
    }

    if (!loaded) {
        return (
            <LoadingPane />
        );
    }

    return (
        <WidthConstrainedContainer maxWidth={1000}>
            <Card noMargin={true}>
                <CardHeader
                    leftSlot={(
                        <Title
                            title={'Albums'}
                            noMargin={true}
                        />
                    )}
                    rightSlot={(
                        <Button
                            label={'Create'}
                            onClick={(event) => navigate(route('admin.album.create', undefined, false))}
                            disabled={disabled || deleting}
                        />
                    )}
                />
                <CardBody>
                    {albumsExists() ? (
                        <>
                            <div className={'row'}>
                                {!!data.data && data.data.map((album, index) => renderAlbum(index, album))}
                            </div>
                            <Modal
                                open={!!previewModalAlbum}
                                title={'Are you sure you want to delete this album?'}
                                icon={Icons.DELETE}
                                confirmText={'Delete'}
                                onConfirm={() => setDeleting(true)}
                                closeText={'Cancel'}
                                onClose={() => setPreviewModalAlbum(null)}
                                disabled={disabled || deleting}
                                variant={Variants.Danger}
                            >
                                {!!previewModalAlbum && (
                                    <>
                                        <Text>
                                            Are you sure that you want to delete this album?
                                        </Text>
                                        <Text>
                                            {previewModalAlbum.title} - {previewModalAlbum.artist}
                                        </Text>
                                        <Text className={'mb-0'}>
                                            This action cannot be undone.
                                        </Text>
                                    </>
                                )}
                            </Modal>
                        </>
                    ) : renderNoAlbums()}
                </CardBody>
            </Card>
        </WidthConstrainedContainer>
    )
}

export default IndexAlbum;
